// extracted by mini-css-extract-plugin
export default {"shinyText":"ShinyText_shinyText__MUohs","shine":"ShinyText_shine__L1QLd","disabled":"ShinyText_disabled__QNDwb"};